// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/trash.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/trash'

import { Icon, type IconComponentProps } from '../icon'

export const TrashIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
